var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "dashboard" } },
    [
      _c("navbar", {
        scopedSlots: _vm._u([
          {
            key: "nav-items",
            fn: function () {
              return [
                _c("li", { staticClass: "nav-item" }, [
                  _c("a", { staticClass: "nav-link" }, [
                    _c("i", {
                      staticClass: "fa fa-home",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n            Dashboard\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("a", { staticClass: "nav-link" }, [
                    _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n            Account Settings\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    { staticClass: "nav-link", on: { click: _vm.logout } },
                    [
                      _c("i", {
                        staticClass: "fa fa-sign-out-alt",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n            Logout\n            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [_c("hr")]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("a", { staticClass: "nav-link btn btn-topbar ml-2" }, [
                    _c("i", {
                      staticClass: "fa fa-plus",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n            Create New Scan\n            "),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("a", { staticClass: "nav-link btn btn-topbar ml-2" }, [
                    _c("i", {
                      staticClass: "fa fa-plus",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n            Generate Risk Report\n            "),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "tab-container" } }, [
        !_vm.collapse
          ? _c("div", {
              staticClass: "tab-overlay",
              on: { click: _vm.tapOpen },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isSidebarVisible
          ? _c(
              "div",
              {
                staticClass: "tab-selection",
                class: {
                  collapse: _vm.collapse,
                  "in-progress": !_vm.isProgressCompleted,
                },
                style: _vm.xOffset,
                attrs: { id: "tab-selection" },
              },
              [
                _c("div", { staticClass: "scan-info" }, [
                  _c("div", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.scan.label)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subheader" }, [
                    _vm._v(
                      "\n                    Revision " +
                        _vm._s(_vm.scan.revision) +
                        "\n                    "
                    ),
                    _c("span", { staticClass: "nav-item mr-5" }, [
                      _vm._v(
                        "\n                        l " +
                          _vm._s(_vm._f("niceDate")(_vm.scan.report_date)) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "report-tab-container report-menu-container" },
                  _vm._l(_vm.tabs, function (tab, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tab-title",
                        class: { selected: tab.component === _vm.selected_tab },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(tab.name) +
                            "\n                    "
                        ),
                        tab.isBetaVersion
                          ? _c(
                              "div",
                              { staticClass: "badge badge-primary badge-sm" },
                              [_vm._v("BETA")]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "report-tab-container integrations-container",
                  },
                  [
                    _c("div", { staticClass: "header" }, [
                      _vm._v("INTEGRATIONS"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icons-container" }, [
                      _c("img", {
                        attrs: { src: "/assets/images/app-icon-256.png" },
                      }),
                      _vm._v(" "),
                      _vm.useQualys
                        ? _c("img", {
                            staticClass: "qualys-icon",
                            attrs: { src: "/assets/images/qualys-logo.png" },
                          })
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "report-tab-container download-btn-container",
                  },
                  [
                    _c("div", { staticClass: "header" }, [_vm._v("DOWNLOADS")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub-header" }, [
                      _vm._v("Download Report"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block download-btn",
                          attrs: {
                            title: "Download full Excel report",
                            id: "download-report",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "file-excel"] },
                          }),
                          _vm._v(
                            "\n                        xlsx\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block download-btn",
                          attrs: {
                            title: "Download zipped CSV report",
                            id: "download-report",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "file-csv"] },
                          }),
                          _vm._v(
                            "\n                        csv\n                    "
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.collapse
          ? _c(
              "div",
              {
                staticClass: "tab-collapsed",
                attrs: { id: "tab-open" },
                on: { click: _vm.tapOpen },
              },
              [_c("i", { staticClass: "fa fa-chevron-right" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "component_wrapper",
            staticClass: "component-wrapper",
            class: { "full-width": !_vm.isSidebarVisible },
          },
          [
            _c("cyber-fitness", {
              attrs: {
                scanId: "9cbe5e67-f45e-453c-a3c2-89943c7f83a1",
                hasAccessToJira: true,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "report-tab-container" }, [
      _c("div", { staticClass: "header" }, [_vm._v("ACTIONS")]),
      _vm._v(" "),
      _c("div", { staticClass: "tab-title" }, [
        _c("a", { staticClass: "action-link" }, [_vm._v("Rescan")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tab-title" }, [
        _c("a", { staticClass: "action-link" }, [_vm._v("Send to Jira")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }